<div class="column" [style.width]="width" [style.textAlign]="textAlign">
  @for (child of children; track child) {
    <ng-template #children></ng-template>
  }
</div>